import React from 'react'
import DashboardEditableRow from '@components/pages/Dashboard/DashboardEditableRow.component'
import DashboardSectionCard from '@components/pages/Dashboard/DashboardSectionCard.component'
import DashboardMetricItem from '@components/pages/Dashboard/DashboardMetricItem.component'
import type { DashboardMetricItemData } from '../../../../../types/dashboardMetrics.types'
import {
  hasNonZeroDashboardValues,
  isDashboardSectionPending,
  shouldShowDashboardSectionEmpty,
} from '@utils/dashboardSectionEmpty.util'
import { metricDataToItemProps } from '@utils/dashboardMetrics.util'

type OverviewUtilizationMetricsProps = {
  editMode?: boolean
  loading: boolean
  /** True once the responses backing these metrics have arrived. */
  hasPayload?: boolean
  row1: DashboardMetricItemData[]
  row2: DashboardMetricItemData[]
  row3: DashboardMetricItemData[]
}

function MetricRow({
  editMode,
  loading,
  metrics,
}: {
  editMode: boolean
  loading: boolean
  metrics: DashboardMetricItemData[]
}): React.ReactElement {
  return (
    <DashboardEditableRow
      editMode={editMode}
      className="dashboard-overview-cards-row"
    >
      {metrics.map((metric) => (
        <DashboardSectionCard
          key={metric.id ?? metric.leftLabel}
          isEmpty={shouldShowDashboardSectionEmpty(
            loading,
            hasNonZeroDashboardValues(metric.value),
          )}
        >
          <DashboardMetricItem {...metricDataToItemProps(metric)} />
        </DashboardSectionCard>
      ))}
    </DashboardEditableRow>
  )
}

export function OverviewUtilizationMetrics({
  editMode = false,
  loading,
  hasPayload = false,
  row1,
  row2,
  row3,
}: OverviewUtilizationMetricsProps): React.ReactElement {
  const pending = isDashboardSectionPending(loading, hasPayload)

  if (pending) {
    return (
      <>
        <DashboardEditableRow
          editMode={editMode}
          className="dashboard-overview-cards-row"
        >
          <DashboardSectionCard loading skeleton={{ metrics: 4 }} />
        </DashboardEditableRow>
        <DashboardEditableRow
          editMode={editMode}
          className="dashboard-overview-cards-row"
        >
          <DashboardSectionCard loading skeleton={{ metrics: 4 }} />
        </DashboardEditableRow>
        <DashboardEditableRow
          editMode={editMode}
          className="dashboard-overview-cards-row"
        >
          <DashboardSectionCard loading skeleton={{ metrics: 4 }} />
        </DashboardEditableRow>
      </>
    )
  }

  return (
    <>
      {row1.length > 0 && (
        <MetricRow editMode={editMode} loading={loading} metrics={row1} />
      )}
      <MetricRow editMode={editMode} loading={loading} metrics={row2} />
      <MetricRow editMode={editMode} loading={loading} metrics={row3} />
    </>
  )
}
